import { Component, Input, OnInit, EventEmitter, Output, Optional } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { PrefixInput, Warning } from '../../../../../utils/models/input.interface';
import { returnColorWarning, returnTextWarning, returnWarningIcon } from '../../../functions/utilities.service';

@Component({
  selector: 'prefix-input-induxtry',
  templateUrl: './prefix-input.component.html',
  styleUrls: ['./prefix-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PrefixInputComponent,
    },
  ],
})
export class PrefixInputComponent implements OnInit, ControlValueAccessor {
  warningIconPrefixInput = returnWarningIcon;
  colorWarningPrefixInput = returnColorWarning;
  textWarningPrefixInput = returnTextWarning;

  @Input() prefixInput: PrefixInput;

  @Input() warning: Warning;

  @Input() formControlName: string;

  @Output() valueEmitter: EventEmitter<string> = new EventEmitter<string>();

  constructor(@Optional() private controlContainer: ControlContainer) { }

  writeValue(value: any): void {
    this.prefixInput.value = value;
  }

  onChange = (value: any) => {
    return value;
  };

  onTouched = (value: unknown) => {
    return value;
  };

  registerOnChange(onChange: (value: any) => any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  ngOnInit(): void {
    if(this.controlContainer) {
      const control = this.controlContainer.control.get(this.formControlName);
      if (control && control.hasValidator(Validators.required)) {
        this.prefixInput.required.active = true;
      }
    }
  }

  setValue() {
    this.onChange(this.prefixInput.value);
    this.valueEmitter.emit(this.prefixInput.value);
  }

  getItemStyle(value){
    return { 'color': value? '#333333' : '#949494'}
  }
}
